export const API_PREFIX = '/api';
export const APP_CONFIG_PREFIX = `${API_PREFIX}/app-config`;
